/**
 * Positions- und Stueckzahl-Zusammenfassung ueber `order.items[]` - OHNE Bestandsvorbild (Auftrag
 * 2, "Zeitstrahlseite: sprechende Zeile, Artikelstreifen, Positions-Popup"). Gebraucht an ZWEI
 * Stellen, die dieselbe Zahl zeigen muessen: der Zeitstrahl-Zeile (`.tlp-order-menge`,
 * `ZeitstrahlSeite.tsx`) und dem Fuss des Positionen-Popups (`PositionenPopup.tsx`, "dieselbe Summe
 * wie in der Zeile"). Eine gemeinsame Fassung statt zweier, die auseinanderlaufen koennten.
 */
import type { OrderItem } from "./types.ts";

/** Positionen = Anzahl der Eintraege, Stueck = Summe der `qty`. */
export interface Positionenzusammenfassung {
  positionen: number;
  stueck: number;
}

/**
 * Nicht-numerische oder fehlende `qty` zaehlen als 0 (Auftragstext) - `Number(undefined)` waere
 * `NaN` und risse die Summe, `Number("")` ebenso.
 */
export function positionenZusammenfassung(
  items: readonly OrderItem[] | null | undefined,
): Positionenzusammenfassung {
  const liste = Array.isArray(items) ? items : [];
  const stueck = liste.reduce((summe: number, item) => {
    const menge = Number(item?.qty);
    return summe + (Number.isFinite(menge) ? menge : 0);
  }, 0);
  return { positionen: liste.length, stueck };
}

/**
 * Die anzuzeigende Kurzform, z. B. `"7 Pos · 1.240 Stk"` - Stueckzahl mit `toLocaleString("de-DE")`
 * gruppiert (Auftragstext). Bei null Positionen liefert sie die leere Zeichenkette; der Aufrufer
 * zeigt dann gar nichts an, statt eine leere Huelle stehen zu lassen (Auftragstext, Zeile 1 Punkt 4).
 */
export function formatPositionenZusammenfassung(
  items: readonly OrderItem[] | null | undefined,
): string {
  const { positionen, stueck } = positionenZusammenfassung(items);
  if (!positionen) return "";
  return `${positionen} Pos · ${stueck.toLocaleString("de-DE")} Stk`;
}
